import { Translation } from 'cng-common/features/translations'
import { IColumn } from 'core-components/library/list/types'
import { FinancialBeautifiedValue } from 'partner360/components/financialBeautifiedValue/FinancialBeautifiedValue'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../configs/translations'
import { IMdfActivity } from '../../../model/types'
import { StatusBadge } from '../components/statusBadge'
import styles from '../MdfActivitiesTable.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.table
const SETTINGS_HIDDEN = false
const SORTING_DISABLED = true

interface IGetSummaryColumnsParams {
  isUsd: boolean
  isActivityClickable?: boolean
}

// Legacy allocation rows can repeat BU values; show each business unit only once.
const joinUnique = (values: string[]): string => Array.from(new Set(values)).join(', ')

export const getSummaryColumns = ({
  isUsd,
  isActivityClickable = true,
}: IGetSummaryColumnsParams): IColumn<IMdfActivity>[] => [
  {
    field: 'activityName',
    title: KEYS.activity,
    disableSort: SORTING_DISABLED,
    hideSettings: SETTINGS_HIDDEN,
    titleRender: () => <Translation text={KEYS.activity} />,
    renderFunction: (item) => (
      <div className={styles.activityCell}>
        <div className={isActivityClickable ? styles.activityName : styles.activityTitle}>
          {item.activityName}
        </div>
        <div className={styles.activitySubtitle}>
          #{item.activityId} · {item.activityType}
        </div>
      </div>
    ),
  },
  {
    field: 'timeframe',
    title: KEYS.timeframe,
    disableSort: SORTING_DISABLED,
    hideSettings: SETTINGS_HIDDEN,
    titleRender: () => <Translation text={KEYS.timeframe} />,
    renderFunction: (item) => <>{item.timeframe}</>,
  },
  {
    field: 'activityStatus',
    title: KEYS.status,
    disableSort: SORTING_DISABLED,
    hideSettings: SETTINGS_HIDDEN,
    titleRender: () => <Translation text={KEYS.status} />,
    renderFunction: (item) => <StatusBadge status={item.activityStatus} />,
  },
  {
    field: 'businessUnit',
    title: KEYS.bu,
    disableSort: SORTING_DISABLED,
    hideSettings: SETTINGS_HIDDEN,
    titleRender: () => <Translation text={KEYS.bu} />,
    renderFunction: (item) => <>{joinUnique(item.businessUnit)}</>,
  },
  {
    field: 'requestedAmountUsd',
    title: KEYS.requested,
    disableSort: SORTING_DISABLED,
    hideSettings: SETTINGS_HIDDEN,
    titleRender: () => <Translation text={KEYS.requested} />,
    renderFunction: (item) => (
      <FinancialBeautifiedValue
        className={styles.financialValue}
        value={isUsd ? item.requestedAmountUsd : item.requestedAmountLc}
        withCurrencySign={isUsd}
        maximumFractionDigits={0}
      />
    ),
  },
  {
    field: 'claimPaidUsd',
    title: KEYS.paid,
    disableSort: SORTING_DISABLED,
    hideSettings: SETTINGS_HIDDEN,
    titleRender: () => <Translation text={KEYS.paid} />,
    renderFunction: (item) => (
      <FinancialBeautifiedValue
        className={styles.financialValue}
        value={isUsd ? item.claimPaidUsd : item.claimPaidLc}
        withCurrencySign={isUsd}
        maximumFractionDigits={0}
      />
    ),
  },
]
